module.exports = __webpack_public_path__ + "static/media/t_nor_01.a9242398.png";